import React from "react";
import { Grid, Typography, Container, Box, Divider } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";

const TermsOfService = () => {
  const state = useSelector((state) => state);

  return (
    <div className="main">
      <Sidebar />

      <div
        className="anigrad"
        style={{
          paddingBottom: "50px",
        }}
      >
        <div
          style={{
            height: "50vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "75vw",
              marginLeft: state.auth.isMobile ? "0px" : "0px",
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "50px" : "80px",
                color: "yellow",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "center" : "left",
              }}
            >
              Terms of Service
            </div>

            <div
              style={{
                borderBottom: "2px solid white",
                width: "100%",
                margin: "15px 0px 15px 0px",
              }}
            ></div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "20px" : "3vh",
                color: "white",
                zIndex: 999,
              }}
            >
              Please read these terms carefully before using our services
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", backgroundColor: "white" }}>
        <Container
          sx={{
            py: 5,
            px: state.auth.isMobile ? 2 : 5,
            mb: 10,
            textAlign: "left",
          }}
        >
          <Box sx={{ mb: 4 }}>
            <Typography variant="body1" paragraph>
              <strong>Effective Date:</strong> 01 January 2025
            </Typography>
            <Typography variant="body1" paragraph>
              These Terms of Service govern your access to and use of all
              services and digital products offered by Riches Media Digital. You
              agree to these terms in full and without modification by using our
              website or engaging with our services. If you disagree with any
              part of these terms, you must not use our services.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              1. Access to Services
            </Typography>
            <Typography variant="body1" paragraph>
              Riches Media Digital provides branding consultation and
              performance marketing solutions tailored to specific business
              needs. Access to our services is granted on a contractual basis.
              You must have an active service agreement or signed project scope
              before we begin work on any deliverable or strategy.
            </Typography>
            <Typography variant="body1" paragraph>
              We reserve the right to restrict access or modify service
              availability based on operational changes or capacity constraints.
              Clients are expected to provide accurate project information,
              feedback, and approvals within agreed timelines to avoid delays or
              disruptions.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              2. Service Scope and Deliverables
            </Typography>
            <Typography variant="body1" paragraph>
              All service deliverables will be documented and approved prior to
              commencement. This includes campaign strategy, content
              deliverables, and ad management workflows. Any modification to
              project scope after execution begins will require written
              confirmation and may be subject to revised timelines or fees.
            </Typography>
            <Typography variant="body1" paragraph>
              The service agreement outlines specific campaign durations,
              reporting structures, and performance metrics. We deliver services
              with professional diligence and use proven platforms or tools
              suited to each business goal. Creative assets remain in our
              control until final clearance and full payment are received.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              3. Intellectual Property
            </Typography>
            <Typography variant="body1" paragraph>
              All content created by Riches Media Digital, including copy,
              design, video material, and advertising concepts, remains our
              intellectual property until all financial dues are cleared. Once
              full payment is made, clients receive usage rights as specified in
              the scope document.
            </Typography>
            <Typography variant="body1" paragraph>
              You may not reproduce, redistribute, or alter any of our
              proprietary materials without written approval. Any unauthorized
              use of our intellectual property may result in legal action or
              service suspension.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              4. Client Responsibilities
            </Typography>
            <Typography variant="body1" paragraph>
              Clients must provide complete brand information, business
              objectives, and access credentials required for campaign
              execution. We rely on accurate data and prompt approvals to
              maintain service timelines.
            </Typography>
            <Typography variant="body1" paragraph>
              Delays caused due to non-cooperation, missing access, or
              incomplete project inputs may impact outcomes. We are not liable
              for campaign underperformance or delay if project dependencies are
              not fulfilled by the client on time.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              5. Payment Terms
            </Typography>
            <Typography variant="body1" paragraph>
              All invoices are payable based on agreed terms in the project
              proposal. Payment cycles may vary by service tier and will be
              mentioned explicitly in the contract. Delayed payments beyond five
              business days after the due date may attract a late fee or lead to
              suspension of ongoing services.
            </Typography>
            <Typography variant="body1" paragraph>
              Refunds are not applicable for completed strategy work or
              campaigns already in execution. All service commitments are tied
              to specific hours or deliverables. If you wish to pause a project,
              you must inform us at least seven working days in advance and
              receive written confirmation.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              6. Performance and Platform Policies
            </Typography>
            <Typography variant="body1" paragraph>
              Riches Media Digital works across advertising platforms including
              Google Ads, Facebook Ads Manager, and other publisher networks. We
              are bound by the advertising and data policies of each platform.
              We will not engage in practices that breach those guidelines.
            </Typography>
            <Typography variant="body1" paragraph>
              We do not guarantee fixed results such as revenue or lead volume,
              as performance depends on multiple variables including industry
              behavior, product-market fit, and platform costs. We work with
              industry benchmarks and refine campaigns through data analysis and
              optimization cycles.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              7. Confidentiality and Data Use
            </Typography>
            <Typography variant="body1" paragraph>
              We treat all client data, campaign information, and brand
              strategies with strict confidentiality. We will never share,
              resell, or disclose sensitive data without prior consent. Access
              to your data is restricted within our internal team and used only
              for your campaigns.
            </Typography>
            <Typography variant="body1" paragraph>
              If third-party integrations are involved, we will notify you and
              limit access to necessary use cases only. All reports, analytics
              dashboards, and performance summaries are hosted in secure
              environments and shared directly with your authorized personnel.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              8. Service Modifications and Termination
            </Typography>
            <Typography variant="body1" paragraph>
              We may modify or discontinue any of our services at our
              discretion, based on regulatory changes, platform constraints, or
              business restructuring. You will receive advance notice of any
              changes affecting ongoing work.
            </Typography>
            <Typography variant="body1" paragraph>
              Clients may terminate the agreement by providing written notice
              with a clear request and reason. Upon cancellation, any pending
              deliverables or dues will be documented, and final clearance will
              be required. We will close out campaigns and hand over approved
              material once exit conditions are fulfilled.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              9. Limitation of Liability
            </Typography>
            <Typography variant="body1" paragraph>
              Riches Media Digital is not liable for loss of revenue, business
              opportunity, or platform account issues resulting from ad
              rejections, account bans, or audience fatigue. We follow best
              practices and platform guidelines, but we do not control publisher
              algorithmic decisions or competitor actions.
            </Typography>
            <Typography variant="body1" paragraph>
              We are also not liable for errors or misinterpretations caused by
              third-party tools or analytics platforms. All data is reviewed
              with reasonable diligence, but real-time updates or outages may
              affect visibility or tracking temporarily.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              10. Legal Jurisdiction
            </Typography>
            <Typography variant="body1" paragraph>
              These terms are governed by the laws of the Republic of India. Any
              dispute arising from or in connection with these terms shall be
              subject to the exclusive jurisdiction of the appropriate courts
              within India.
            </Typography>
          </Box>
        </Container>
      </div>
      <div style={{ marginTop: "-100px" }} />
      <Footer />
    </div>
  );
};

export default TermsOfService;
